import React, { useState } from "react";

import DetailModal from "../ui/DetailModal";
import { Button } from "../ui";

function DoorNoteModal({ addNote, showNotesModal, setShowNotesModal }) {
    const [description, setDescription] = useState("");

    const handleClose = () => {
        setDescription("");
        setShowNotesModal(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!description.trim()) return;
        addNote({ description: description.trim() });
        setDescription("");
        setShowNotesModal(false);
    };

    return (
        <DetailModal
            open={showNotesModal}
            onClose={handleClose}
            title="Add Door Note"
            size="md"
            actions={
                <>
                    <Button variant="secondary" size="sm" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        size="sm"
                        onClick={handleSubmit}
                        disabled={!description.trim()}
                    >
                        Add Note
                    </Button>
                </>
            }
        >
            <form onSubmit={handleSubmit}>
                <label
                    htmlFor="door-note-description"
                    style={{
                        display: "block",
                        marginBottom: "0.4rem",
                        fontSize: "0.8rem",
                        fontWeight: 700,
                        letterSpacing: "0.05em",
                        textTransform: "uppercase",
                        color: "#64748b",
                    }}
                >
                    Note
                </label>
                <textarea
                    id="door-note-description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    rows={5}
                    placeholder="Enter a note for production or installers..."
                    autoFocus
                    style={{
                        width: "100%",
                        padding: "0.6rem 0.75rem",
                        fontSize: "0.95rem",
                        color: "#1e293b",
                        background: "#f8fafc",
                        border: "1px solid #e2e8f0",
                        borderRadius: "8px",
                        resize: "vertical",
                        outline: "none",
                        lineHeight: 1.5,
                        transition: "border-color 0.15s ease, box-shadow 0.15s ease",
                    }}
                    onFocus={(e) => {
                        e.target.style.borderColor = "#2c7aa0";
                        e.target.style.boxShadow = "0 0 0 3px rgba(44,122,160,0.12)";
                        e.target.style.background = "#ffffff";
                    }}
                    onBlur={(e) => {
                        e.target.style.borderColor = "#e2e8f0";
                        e.target.style.boxShadow = "none";
                        e.target.style.background = "#f8fafc";
                    }}
                />
            </form>
        </DetailModal>
    );
}

export default DoorNoteModal;
